module.exports = __webpack_public_path__ + "media/images/talent/story-02-7988a0cce42bfb540cd34d89370c0e87.png";